export default "__VITE_ASSET__Ds$64Lgo__"